import React from 'react';

const ModalDownload = props => (
  <div
    data-close="ok"
    onClick={props.handleModal}
    className={props.modal ? `container-modal` : `container-modal hide`}
  >
    <section className="module-title modal-title">
      <h2>{props.language.account.homologationDriver.howCreatedExcel}</h2>
      <a>
        <i data-close="ok" onClick={props.handleModal} className="fas fa-times-circle" />
      </a>
    </section>

    <div className="box-form islabel center modal-button-box">
      <div>
        <input
          onClick={props.handleDownload}
          className="active"
          type="button"
          value={props.language.account.homologationDriver.buttonDownload}
        />
      </div>
    </div>
  </div>
);

export default ModalDownload;



// WEBPACK FOOTER //
// ./source/client/components/homologation_vehicle/modalDownload.jsx